import { tap, mergeMap, filter } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { Injectable } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { createEffect } from '@ngrx/effects';

@Injectable()
export class RouterEffects {
  scrollToTop$: Observable<any> = createEffect(
    () =>
      this.router.events.pipe(
        filter((event) => event instanceof NavigationEnd),
        tap(() => window.scrollTo(0, 0))
      ),
    { dispatch: false }
  );

  setTitle$: Observable<any> = createEffect(
    () =>
      this.router.events.pipe(
        filter((event) => event instanceof NavigationEnd),
        mergeMap(() => this.route.firstChild!.data),
        tap((data) =>
          this.titleService.setTitle(
            `GoArmy Edge${data.title ? ` - ${data.title}` : ''}`
          )
        )
      ),
    { dispatch: false }
  );

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private titleService: Title
  ) {}
}
